import { getMediaUrlDimensions } from '../media-url-dimensions/media-url-dimensions';
export function getResizedImageUrl(mediaManager, mediaItem, requiredDimensions) {
    var dimensions = getMediaUrlDimensions(mediaItem, requiredDimensions);
    if (dimensions) {
        return mediaManager.getResizedImageUrl(mediaItem.url, dimensions.width, dimensions.height);
    }
    else {
        return mediaManager.getImageUrl(mediaItem.url);
    }
}
//# sourceMappingURL=resized-image-url.js.map